import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { TrackerService } from '../../services/tracker.service';
import { TrackeritemService } from '../../services/trackeritem.service';
import { MentionConfig } from '../../../../core/services/core.mentio.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-fields',
  template: require('./trackeritem.fields.component.html'),
})
export class TrackerItemFieldsComponent implements OnInit {
  mode: string;
  fieldValidationMode: any;

  @Input() tracker: any;
  @Input() trackeritem: any;
  @Input() tags: any;
  @Input() allowUpdate: boolean;
  @Input() allowAdminOperation: boolean = false;
  @Input() errors: any;
  @Input() acls: any;
  /** The @-mention source, passed straight through to the details editor. */
  @Input() mentionSource: MentionConfig | null = null;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onTagsUpdate: EventEmitter<any> = new EventEmitter();

  isNewTrackerItem: boolean;
  priorityOptions: any;
  waitingForOptions: any;
  storyPointsOptions: any;
  isLoaded: boolean = false;

  constructor(
    private translateService: GfTranslateService,
    private TrackerService: TrackerService,
    public trackeritemService: TrackeritemService,
  ) {}

  ngOnInit(): void {
    this.isNewTrackerItem = !(this.trackeritem.id > 0);

    this.priorityOptions = {
      id: 'priority',
      fieldName: this.translateService.translate('Priority'),
      fieldElements: this.TrackerService.fields.builtIn.priority.getList()
    };

    this.waitingForOptions = {
      id: 'waiting_for',
      fieldName: this.translateService.translate('Waiting For'),
      fieldElements: this.TrackerService.fields.builtIn.waiting_for.getList()
    };

    this.storyPointsOptions = {
      id: 'story_points',
      fieldName: this.translateService.translate('Story Points'),
      fieldElements: this.TrackerService.fields.builtIn.story_points.getStoryPointsOptionsList(
        this.tracker?.fields?.storyPoints?.fieldElements,
        this.tracker?.fields?.storyPoints?.defaultSelected
      )
    };

    if (!_.has(this.errors, 'summary')) {
      this.errors.summary = {};
    }

    this.isLoaded = true;
  }

  onChange(): void {
    this.isNewTrackerItem = !(this.trackeritem.id > 0);
  }

  notifyUpdate(fieldAlias: string, value: any): void {
    this.onUpdate.emit({ fieldAlias, value });
  }

  handlePriorityChange(newPriority: any): void {
    this.trackeritem.priority = newPriority;
  }

  handleWaitingForChange(newWaitingFor: any): void {
    this.trackeritem.waitingFor = newWaitingFor;
  }

  handleStoryPointsChange(newStoryPoints: any): void {
    this.trackeritem.storyPoints = newStoryPoints;
  }

  /**
   * Ref id for image uploads from the details editor. Saved items use their
   * own id; new items use the temp id minted by TrackeritemService so the
   * upload service can re-associate files when the item is persisted.
   */
  get detailsUploadRefId(): number {
    return this.isSavedTrackerItem() ? this.trackeritem.id : this.trackeritemService.getTempTid();
  }

  /**
   * Section for image uploads from the details editor. A new item has no id to
   * check permissions against, so uploads go into the temporary section — the
   * backend accepts it unconditionally and re-points those files at the real
   * section/refId once the item is saved (see TrackerItemBackendService).
   */
  get detailsUploadSection(): string {
    return this.isSavedTrackerItem()
      ? this.trackeritemService.getSection()
      : this.trackeritemService.getSectionTmp();
  }

  private isSavedTrackerItem(): boolean {
    return _.get(this.trackeritem, 'id', 0) > 0;
  }

  checkValidationFailureMode(fieldName: String = '') {
    return !_.get(this.errors, fieldName + '.hasError', false);
  }

  onDetailsUpdate(details) {
    this.trackeritem.details = details;
    this.trackeritem.detailsFormat = 'text/markdown';
  }

  onOpenDateUpdate($event) {
    this.trackeritem.openDate = $event;
  }

  onCloseDateUpdate($event) {
    this.trackeritem.closeDate = $event;
  }

  tagsUpdated($event) {
    this.onTagsUpdate.emit($event);
  }

  setSubmitter(members: any): void {
    if (this.trackeritem && members.length > 0) {
      this.trackeritem.submittedBy = members[0];
      this.notifyUpdate('submittedBy', members[0]);
    }
  }

  goTo(route: string, params: any): void {
    // This method should be implemented by the parent component
    // For now, we'll emit an event
    this.onUpdate.emit({ action: 'navigate', route, params });
  }

}
